import { appItem } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mx-auto mb-5">
            <i className="ri-smartphone-line text-3xl md:text-4xl"></i>
          </div>
          <h2 className="section-title">移动阅读</h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            {appItem.desc}
          </p>
          <div className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-secondary-100 text-secondary-700 text-sm">
            <i className="ri-information-line w-4 h-4 flex items-center justify-center"></i>
            <span>{appItem.tips}</span>
          </div>
        </div>
      </div>
    </section>
  );
}